import styled from "styled-components";
import background from "../assets/background.png";

const GameListContainer = styled.div`
  width: 20%;
  max-height: calc(100vh - 100px);
  border-right: 2px solid #79559a;
  overflow-y: scroll;
  scrollbar-color: #af9dc4 white;
  scrollbar-width: thin;
  user-select: none;


  @media (min-width: 1025px) and (max-width: 1440px) {
    width: 25%;
  }

  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    width: 23%;
  }
`;

const GameDetailsContainer = styled.div`
  width: 80%;
  background-image: url(${background});
  background-repeat: no-repeat;
  background-size: cover;
  padding: 2.5em;
  box-sizing: border-box;

  h1 {
    color: #673c8c;
    margin: 0;
    margin-bottom: 0.25em;
    font-size: 4em;
    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
      font-size: 3.5em;
    }
  }

  @media (min-width: 1025px) and (max-width: 1440px) {
  }

  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  }
`;

const ProgressContainer = styled.div`
  width: 80%;
  background-image: url(${background});
  background-repeat: no-repeat;
  background-size: cover;
  padding: 2.5em;
  box-sizing: border-box;

  h1 {
    color: #673c8c;
    margin: 0;
    margin-bottom: 0.25em;
    font-size: 4em;
    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
      font-size: 3.5em;
    }
  }

  @media (min-width: 1025px) and (max-width: 1440px) {
  }

  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  }
`;

const InfoContainer = styled.div`
  width: 70%;
  margin-right: 5%;

  img {
    width: auto;
    height: auto;
    display: block;
    margin: 0px auto;

    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
      height: 30em;
    }
  }

  p {
    color: #673c8c;
    font-size: 3em;
    font-weight: bold;
    height: 85px;

    @media (min-width: 1025px) and (max-width: 1440px) {
      font-size: 2.5em;
      height: 105px;
    }

    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
      font-size: 2em;
    }
  }
`;

const StatsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 30%;
  justify-content: center;
  margin: 0em 5em;
  box-sizing: border-box;

  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    margin: 0em;

    img {
      max-width: 20em;
    }
  }
`;

const ShowGameContainer = styled.div`
  width: 100%;
  
  background-repeat: no-repeat;
  background-size: cover;
  padding: 2.5em;
  box-sizing: border-box;
  height: 100vh;

  h1 {
    color: #673c8c;
    margin: 0;
    margin-bottom: 0.25em;
    font-size: 4em;
    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
      font-size: 3.5em;
    }
  }

  @media (min-width: 1025px) and (max-width: 1440px) {
  }

  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  }
`;

const MenuContainer = styled.div`
  width: 500px;
  padding: 1px 21px 1px 21px;
  background: #fff;
  margin: 0px auto;
  display: block;
  border-radius: 10px;
`;

const TopicsContainer = styled.div`
  width: 100%;
  background-image: url(${background});
  background-repeat: no-repeat;
  background-size: cover;
  padding: 2.5em;
  box-sizing: border-box;
  height: 100vh;

  h1 {
    color: #673c8c;
    margin: 0;
    margin-bottom: 0.25em;
    font-size: 4em;
    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
      font-size: 3.5em;
    }
  }

  @media (min-width: 1025px) and (max-width: 1440px) {
  }

  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  }
`;

const LevelListContainer = styled.div`
  height: 490px;
  width: 20%;
  overflow: auto;
  float: left;

  h4 {
    margin: 0px;
  }

  button {
    margin-top: 0px;
    width: 90%;
  }
`;

const GameSelectionContainer = styled.div`
  width: 70%;
  float: left;
  height: 576px;
  background: #fff;
  border-radius: 5px;
  border: 1px solid #683d8c;
  padding: 20px;
  margin-right: 5%;
  margin-top: 1em;
  overflow-y: scroll;

  label {
    height: 2em;
  }
`;

export
{
  GameListContainer,
  GameDetailsContainer,
  InfoContainer,
  StatsContainer,
  ShowGameContainer,
  MenuContainer,
  TopicsContainer,
  LevelListContainer,
  GameSelectionContainer,
  ProgressContainer
};
